import { Component, OnInit, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormsModule, FormControl } from '@angular/forms';
import { AppService } from '../../app.service';
import { FiltrosService } from './filtros.service';
import { MomentDateAdapter} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { MatDatepicker} from '@angular/material/datepicker';
import { AuthService } from '../../auth.service';
import * as _moment from 'moment';
import {default as _rollupMoment, Moment} from 'moment';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-filtros',
  templateUrl: './filtros.component.html',
  styleUrls: ['./filtros.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}, AppService,
  ]
})
export class FiltrosComponent implements OnInit {

  datosGrafico:any;
  syear: number;
  smonth: number;
  public todo : FormGroup;
  datefromc= new FormControl(moment().format('YYYY-MM-DD'));
  datetoc= new FormControl(moment().format('YYYY-MM-DD'));
  origin: any;
  dashboardType:string;
  minDate= new Date(2004, 0, 1);
  maxDate= moment().subtract(3, 'years');
  constructor( private formBuilder: FormBuilder, public appService: AppService, private filtrosService: FiltrosService, private auth: AuthService) {

    auth.user$.subscribe(user => {
      if (user.userType==="pro") {
        this.maxDate= moment();

      }
   })

  this.todo = this.formBuilder.group({
    product: ['', Validators.required],
    input: ['',Validators.required],
    calcmt: ['',Validators.required],
    company: ['',Validators.required],
    charttype: ['',Validators.required],
    frecuency: ['',Validators.required],
    datefrom: [{value: '', disabled: true }, Validators.required],
    dateto: [{value: '', disabled: true }, Validators.required ],
    origin: ['',Validators.required],
    destination: ['',Validators.required],
  });

  filtrosService.filtrosCarga$.subscribe(
  resp => {
    console.log(resp.dashboardType);
    this.dashboardType = resp.dashboardType;
    if (resp.frecuency ==null) {
      this.todo.reset();
    }
    else {
      delete resp.dashboardType;
      this.loadFilterData(resp.origin);
      this.datosGrafico = resp;
      this.todo.setValue(resp);
      this.datefromc.setValue(resp.datefrom);
      this.datetoc.setValue(resp.dateto);
    }
  });
}
    filtros: any = []

generarGrafico() {
  this.todo.value.datefrom = this.datefromc.value;
  this.todo.value.dateto = this.datetoc.value;
  this.filtrosService.actualizarFiltros(this.todo.value);
}

loadFilterData(country) {

  try {
    this.appService.getFilterData(country)
      .subscribe(resp => {
        //console.log(resp, "res");
        this.filtros = resp;
      },
        error => {
          console.log(error, "error");
        })
  }
  catch (e) {
   console.log(e);
 }

}

  ngOnInit() {
    this.getOrigin()

    if (this.datosGrafico) {
      console.log(this.datosGrafico.origin);
      this.loadFilterData(this.datosGrafico.origin);
      this.todo.setValue(this.datosGrafico);
      console.log("hay datos");
    }
    else {
      this.todo.reset();
      this.todo.value.calcmt='original';
    }

  }
  ngOnChanges(changes: SimpleChanges) {

    console.log(changes);
    if (this.datosGrafico) {
    console.log(this.datosGrafico.origin);
    this.loadFilterData(this.datosGrafico.origin);
    console.log("hay datos");
    this.todo.setValue(this.datosGrafico);
    }
    else {
      console.log("no hay datos");
      this.todo.reset();
      this.todo.value.calcmt='original';
      console.log(this.todo.value);
    }
  }

 setDate(event: { monthIndex: number, year: number }) {
   console.log('entro');
   let month = event.monthIndex+1
   this.todo.controls['dateto'].setValue(month+'/'+event.year);

 }
 getOrigin() {
   this.appService.getOriginData()
     .subscribe(resp => {
       this.origin = resp;
     },
       error => {
         console.log(error, "error");
       })
 }
 _openDatepickerOnClick(datepicker: MatDatepicker<Moment>) {
    if (!datepicker.opened) {
      datepicker.open();
    }
  }
    chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
      const value = normalizedMonth.format('YYYY-MM-DD');
      console.log(value);
      this.datefromc.setValue(value);
      this.todo.value.datefrom = value;
      datepicker.close();
    }
    chosenMonthDateto(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
      normalizedMonth.endOf("month");
      const value = normalizedMonth.format('YYYY-MM-DD');
      console.log(value);
      this.datetoc.setValue(value);
      this.todo.value.dateto = value;
      datepicker.close();
    }
}
